import { string } from '@iwentsourcing/core/typing/string.js';
import { optional } from '@iwentsourcing/core/typing/optional.js';
import { union } from '@iwentsourcing/core/typing/union.js';
import { literal } from '@iwentsourcing/core/typing/literal.js';
import { date } from '@iwentsourcing/core/typing/date.js';
import { declareState } from '@iwentsourcing/core/storage/declare-state.js';
import { EventAuth } from '@iwentsourcing/core/event-store/event-auth.js';
import { defineState } from '@iwentsourcing/core/storage/define-state.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { Todo, todoState } from '../todo/state.js';

export const TodoGroup = declareState(
  'group',
  {
    id: string(),
    name: string(),
    createdAt: date(),
  },
  ['id'] as const,
);
export type TodoGroup = TypeOfEvent<typeof TodoGroup>;

export const TodoGroupMember = declareState(
  'groupMembers',
  {
    id: string(),
    name: optional(string()),
    email: optional(string()),
    state: union('TodoGroupState', [literal('invited'), literal('accepted')]),
    auth: EventAuth,
    createdAt: date(),
  },
  ['id'] as const,
).index('name', ['name']);

export const groupState = defineState([
  Todo,
  TodoGroup,
  TodoGroupMember,
]);

export type GroupState = typeof groupState;
